/**
 * Device-local vehicle comparison store (no customer login).
 *
 * The phone remembers which vehicles the shopper is comparing. Comparisons are
 * ISOLATED PER DEALERSHIP (organization_id) — a shopper can never accidentally
 * mix vehicles from two different dealerships in one comparison.
 */
const KEY = (orgId) => `yot_compare_${orgId}`;
const ACTIVE_ORG = 'yot_compare_active_org';
const CONV = (cardId) => `yot_conv_${cardId}`;

const read = (k) => {
    try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch { return []; }
};

export const compareStore = {
    list(orgId) { return orgId ? read(KEY(orgId)) : []; },
    count(orgId) { return this.list(orgId).length; },
    has(orgId, cardId) { return this.list(orgId).includes(cardId); },
    add(orgId, cardId) {
        if (!orgId || !cardId) return;
        const list = this.list(orgId);
        if (!list.includes(cardId)) {
            list.push(cardId);
            localStorage.setItem(KEY(orgId), JSON.stringify(list));
        }
        this.setActiveOrg(orgId);
    },
    remove(orgId, cardId) {
        if (!orgId) return;
        localStorage.setItem(KEY(orgId), JSON.stringify(this.list(orgId).filter((c) => c !== cardId)));
    },
    toggle(orgId, cardId) {
        this.has(orgId, cardId) ? this.remove(orgId, cardId) : this.add(orgId, cardId);
        return this.has(orgId, cardId);
    },
    clear(orgId) { if (orgId) localStorage.removeItem(KEY(orgId)); },
    activeOrg() { return localStorage.getItem(ACTIVE_ORG) || ''; },
    setActiveOrg(orgId) { if (orgId) localStorage.setItem(ACTIVE_ORG, orgId); },
};

/** Remembers the customer's CONFIDENTIAL insurance thread id per card. Kept in
 *  its own key so the insurance conversation is never mixed with — or resumed
 *  as — the ordinary sales thread. */
export const insConvStore = {
    get(cardId) { return cardId ? localStorage.getItem(`yot_ins_conv_${cardId}`) || '' : ''; },
    set(cardId, reqId) { if (cardId && reqId) localStorage.setItem(`yot_ins_conv_${cardId}`, reqId); },
};

/** Remembers the customer's sales conversation id per card (bearer token). */
export const convStore = {
    get(cardId) { return cardId ? localStorage.getItem(CONV(cardId)) || '' : ''; },
    set(cardId, reqId) { if (cardId && reqId) localStorage.setItem(CONV(cardId), reqId); },
    // A thread the server no longer has (demo reset, purged record) must be
    // forgotten, or every later message is POSTed into a 404 and silently lost.
    clear(cardId) { if (cardId) localStorage.removeItem(CONV(cardId)); },
};
